export default __webpack_public_path__ + "static/bncff-mobile-3-mobile-4931b36c816a80a870a325f91e183200.jpg";